import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import DesignItem from '@components/DesignItem';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import { fetchMaterialProducts } from '@services/commonService';

const ProductList = ({ type }) => {
	const [designIdToView, setDesignIdToView] = useState(null);
	const [productList, setProductList] = useState(null);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		getProductList();
	}, [id]);

	const getProductList = async () => {
		let params = `?size=100&page=0`;
		let requestBody = { baseMaterialId: id };
		const data = await fetchMaterialProducts(params, requestBody);
		setProductList(data);
	};

	const renderUsedDesignList = () => {
		return productList?.data?.map((design, index) => {
			return (
				<div key={design?.id}>
					<DesignItem
						design={design}
						fromPage="MATERIAL"
						index={index}
						onClickDesignImage={() => setDesignIdToView(design?.id)}
						key={`design_${index}`}
					/>
				</div>
			);
		});
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: designIdToView,
				onCloseViewModal: () => {
					setDesignIdToView(null);
					dispatch(clearDesignViewModalInfo({}));
				},
				onUpdateCostingStatus: () => false,
				updateProductStatus: () => false,
				source: 'OTHERS'
			})
		);
	};

	return (
		<div className="design-list-container bg-white p-4 mt-3">
			{productList && (
				<>
					<span className="semibold-16">
						This {type} used: {productList?.totalElements}{' '}
						{productList?.totalElements > 1 ? 'styles' : 'style'}
					</span>
					<div className="mt-3 design-list-row">{renderUsedDesignList()}</div>
				</>
			)}
		</div>
	);
};

export default ProductList;
